/* eslint-disable */
export default {
  copyToClipboard: '复制到剪贴板',
} as const;

// @key: @#@"copyToClipboard"@#@ @source: @#@"Copy to Clipboard"@#@
